'use client';

import { forwardRef } from 'react';

export interface Props extends React.VideoHTMLAttributes<HTMLVideoElement> {
  src: string;
}

const defaultBounds = {
  width: 320,
  height: 240,
};

export const Video = forwardRef<HTMLVideoElement, Props>((props: Props, ref) => {
  const {
    src,
    className,
    autoPlay = false,
    muted = false,
    loop = false,
    controls = false,
    height,
    width,
    ...rest
  } = props;
  const bounds = { width: width || defaultBounds.width, height: height || defaultBounds.height };

  return (
    <video
      ref={ref}
      playsInline
      preload="none"
      className={className}
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
      controls={controls}
      width={bounds.width}
      height={bounds.height}
      {...rest}
    >
      <source src={src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
});

Video.displayName = 'Video';
